import { render } from "./AppCustomersList.vue?vue&type=template&id=7bf11195"
import script from "./AppCustomersList.vue?vue&type=script&lang=js"
export * from "./AppCustomersList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__